import { type Components } from '@mui/material'
import { red } from '../customColors'

export const Input: Partial<Components> = {
  MuiTextField: {
    styleOverrides: {
      root: {
        // color: '#62708С',
        // borderRadius: '30px',
        // background: '#FFF',
        // border: '2px solid #F5F6F7',
        '& .MuiInputBase-root': {
          color: '#62708С',
          borderRadius: '30px',
          background: '#FFF',
          border: '2px solid #F5F6F7'
        },
        '& .Mui-error': {
          border: `2px solid ${red[500]}`,
          borderRadius: '30px',
          color: red[500]
        },
        '& fieldset': {
          borderColor: '#F5F6F7'
        },
        '&.Mui-focused': {
          border: '2px solid #EDEFF2',
          '& fieldset': {
            borderColor: '#EDEFF2'
          }
        }
        // '&:hover': {
        //   border: '2px solid #EDEFF2',
        //   '& fieldset': {
        //     borderColor: '#EDEFF2'
        //   }
        // }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: 14,
        '.MuiOutlinedInput-notchedOutline': { border: 0 }
      }
    }
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        background: '#FFF',
        border: '2px solid #F5F6F7',
        color: '#7D8FB3',
        borderRadius: '30px',
        paddingLeft: 15,
        paddingRight: 15,
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: 0.01,
        ':focus': {
          border: '2px solid #EDEFF2'
        }
      },
      icon: {
        fill: '#7D8FB3'
      },
      outlined: {
        paddingLeft: '28px'
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: '#ADADAD',
        fontSize: 14,
        fontWeight: 500
      }
    }
  }
}
